import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios
    .get(`${url}/inspection-form-sections`, options)
    .then((response) => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta,
      };
    });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/inspection-form-sections/${id}?include=inspectionFormSection,inspectionFormSectionFields`,
      options
    )
    .then((response) => {
      let inspectionFormSection = jsona.deserialize(response.data);
      delete inspectionFormSection.links;
      return inspectionForm;
    });
}

function add(inspectionFormSection) {
  const payload = jsona.serialize({
    stuff: inspectionFormSection,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/inspection-form-sections`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(inspectionFormSection) {
  const payload = jsona.serialize({
    stuff: inspectionFormSection,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/inspection-form-sections/${inspectionFormSection.id}`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/inspection-form-sections/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
